"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceRunner = void 0;
const interpreter_1 = require("../interpreter/interpreter");
const parser_1 = require("../parser/parser");
const schedulers_1 = require("../schedulers");
const types_1 = require("../types");
const utils_1 = require("./utils");
const DEFAULT_SOURCE_OPTIONS = {
    scheduler: 'async',
    steps: 1000,
    stepLimit: 1000,
    executionMethod: 'auto',
    variant: types_1.Variant.DEFAULT,
    originalMaxExecTime: 1000,
    useSubst: false,
    isPrelude: false,
    throwInfiniteLoops: true
};
function sourceRunner(code, context, options = {}) {
    const theOptions = Object.assign(Object.assign({}, DEFAULT_SOURCE_OPTIONS), options);
    context.variant = DEFAULT_SOURCE_OPTIONS.variant;
    context.errors = [];
    try {
        const program = (0, parser_1.parse)(code, context);
        if (!program) {
            return utils_1.resolvedErrorPromise;
        }
        const it = (0, interpreter_1.evaluate)(program, context);
        const scheduler = new schedulers_1.PreemptiveScheduler(theOptions.steps);
        return scheduler.run(it, context);
    }
    catch (e) {
        context.errors.push(e);
        context.runtime.environments = context.runtime.environments.slice(-context.numberOfOuterEnvironments);
        return Promise.resolve({ status: 'error', error: e });
    }
}
exports.sourceRunner = sourceRunner;
//# sourceMappingURL=sourceRunner.js.map